export enum CompanyAddressField {
    ID = 'id',
    COMPANY_ID = 'clientId',
    NAME = 'name',
    ADDRESS = 'address',
}
